import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import firebase from "../../Firebase";
import matchSorter from "match-sorter";
import { Card, CardBody, CardHeader, CardTitle, Row, Col } from "reactstrap";
import { Modal as Modals, Button as Buttons, Tooltip, Dropdown, Menu, Icon } from "antd";
import StatusTag from "../../components/StatusTag/StatusTag";
import TableLegend from "../../components/TableLegend/TableLegend";
import EditPasswordModal from "../../components/Modal/EditPasswordModal";
import EngineeringDeletionModal from "../../components/Modal/EngineeringDeletionModal";
import { cortes, costura, acabado, almacen } from "variables/DataTable.jsx";
import "./ConsultaIngenieria.scss";
import downloadFile from "../../utils/downloadFile";

class RegularTables extends React.Component {
  constructor() {
    super();
    this.state = {
      datos: [],
      page: null,
      prof: [],
      ft: [],
      op: [],
      hc: [],
      loading: true,
      modalIsOpen: false,
      descripcion: "",
      color: [],
      cantidad: [],
      fechaIngreso: "",
      ordenPedido: "",
      password: "",
      telaData: [],
      visible: false,
      modalTitleOp: "",
      modalTitleProf: "",
      editModalVisible: false,
      deleteModalVisible: false,
      targetIng: null,
      expanded: {},
      deleteModalIsOpen: false,
      targetProf: null,
      targetOp: null,
    };
  }

  async loadData() {
    const comercialSnapshot = await firebase
      .firestore()
      .collection("comercial")
      .get();
    const etapasPorColor = new Map();
    comercialSnapshot.docs.forEach((doc) => {
      const item = doc.data();
      (item.otros || []).forEach((v) => {
        etapasPorColor.set(`${item.prof}|${item.op}|${v.color}`, {
          telas: v.telas ? [v.telas] : [],
          corte: v.corte ? [v.corte] : [],
          costura: v.costura ? [v.costura] : [],
          acabado: v.acabado ? [v.acabado] : [],
          almacen: v.almacen ? [v.almacen] : [],
        });
      });
    });
    const sinEtapas = { telas: [], corte: [], costura: [], acabado: [], almacen: [] };

    await firebase
      .firestore()
      .collection("ing")
      .orderBy("order", "desc")
      .get()
      .then((querySnapshot) => {
        //const datos = [];
        const data = querySnapshot.docs.reduce((acc, data) => {
          const colores = data.data().otros.map((v) => v.color);
          const item = data.data();
          const itemIndex = acc.findIndex(
            (accItem) => accItem.prof === item.prof
          );
          const estado =
            item.estado && item.estado.length ? item.estado[0] : "";
          const listaOtros = item.otros && item.otros.length ? item.otros : [];
          const detalles = item.otros.reduce((ac, v) => {
            ac.push({
              color: v.color && v.color.length ? v.color : "",
              cantidad:
                (v.cant && v.cant.length ? v.cant : "") ||
                (v.cantidad && v.cantidad.length ? v.cantidad : ""),
              status: [v.status],
              ...(etapasPorColor.get(`${item.prof}|${item.op}|${v.color}`) || sinEtapas),
            });
            return ac;
          }, []);

          const getStatus = data
            .data()
            .otros.every(
              (item) =>
                item.status[0] === "Despachado" ||
                item.status[0] === "Liquidado"
            );
          let newItem = [{}];

          if (itemIndex >= 0) {
            newItem = {
              ...acc[itemIndex],
              otros: acc[itemIndex].otros.concat({
                prof: item.prof,
                op: item.op,
                cx: item.cx,
                fichaTecnica: item.fichaTecnica,
                b: (item.b !== undefined) & (item.b !== []) ? item.b[0] : [],
                hojaConsumo: item.hojaConsumo,
                hc: item.hc,
                moldes: item.moldes || "",
                moldesUrl: item.moldesUrl || "",
                tizadoDdp: item.tizadoDdp || "",
                tizadoDdpUrl: item.tizadoDdpUrl || "",
                descripcion: item.descripcion,
                estado: estado,
                fecha:
                  listaOtros && listaOtros.length ? listaOtros[0].fecha : [],
                estadoProf: item.otros.length
                  ? getStatus
                    ? "Completo"
                    : "Pendiente"
                  : "Pendiente",
                valores: {
                  id: item.index,
                  prof: item.prof,
                  estado: [item.estado[0]],
                  color: colores,
                  op: item.op,
                  isEditable: !item.isEditable,
                  index: item.estado.concat(item.index),
                },
                edit: {
                  doc: item.index,
                  prof: item.prof,
                  fechaIngreso: item.cFechaIngreso,
                  ordenPedido: item.op,
                  descripcion: item.descripcion,
                  color: item.color,
                  cantidad: item.cantidad,
                  estado: item.estado && item.estado.length ? item.estado[0] : "",
                  isEditable: !item.isEditable,
                  cx: item.cx && item.cx.length ? item.cx[0] : "",
                },
                detalles,
              }),
            };
            acc.splice(itemIndex, 1, newItem);
          } else {
            newItem = {
              cFechaIngreso: item.cFechaIngreso,
              prof: item.prof,
              a: item.a[0] ? item.a[0] : [],
              cliente: item.cliente,
              cFechaEntrega: item.cFechaEntrega,
              index: item.index,
              estado: estado,
              estadoProf: item.otros.length
                ? getStatus
                  ? "Completo"
                  : "Pendiente"
                : "Pendiente",

              otros: [
                {
                  prof: item.prof,
                  op: item.op,
                  cx: item.cx,
                  fichaTecnica: item.fichaTecnica,
                  b: (item.b !== undefined) & (item.b !== []) ? item.b[0] : [],
                  hojaConsumo: item.hojaConsumo,
                  hc: item.hc,
                  moldes: item.moldes || "",
                  moldesUrl: item.moldesUrl || "",
                  tizadoDdp: item.tizadoDdp || "",
                  tizadoDdpUrl: item.tizadoDdpUrl || "",
                  descripcion: item.descripcion,
                  estado: estado,
                  fecha:
                    listaOtros && listaOtros.length ? listaOtros[0].fecha : [],
                  estadoProf: item.otros.length
                    ? getStatus
                      ? "Completo"
                      : "Pendiente"
                    : "Pendiente",
                  valores: {
                    id: item.index,
                    prof: item.prof,
                    estado: [item.estado[0]],
                    color: colores,
                    op: item.op,
                    isEditable: !item.isEditable,
                    index: item.estado.concat(item.index),
                  },
                  edit: {
                    doc: item.index,
                    prof: item.prof,
                    fechaIngreso: item.cFechaIngreso,
                    ordenPedido: item.op,
                    descripcion: item.descripcion,
                    color: item.color,
                    cantidad: item.cantidad,
                    estado: item.estado && item.estado.length ? item.estado[0] : "",
                    isEditable: !item.isEditable,
                    cx: item.cx && item.cx.length ? item.cx[0] : "",
                  },
                  detalles,
                },
              ],
            };
            acc.push(newItem);
          }

          return acc;
        }, []);
        this.setState({ data, loading: false });
      });
  }

  componentDidMount() {
    this.loadData();
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };

  prepBorrar = (prof, op) => {
    this.setState({
      deleteModalIsOpen: true,
      targetProf: prof,
      targetOp: op
    });
  };

  onDeleteSuccess = () => {
    const { targetProf, targetOp, data } = this.state;
    const newData = data.map(item => {
      if (item.prof === targetProf) {
        const otros = item.otros.filter(o => o.op !== targetOp);
        return { ...item, otros };
      }
      return item;
    }).filter(item => item.otros.length > 0);

    this.setState({
      data: newData,
      deleteModalIsOpen: false,
      targetProf: null,
      targetOp: null
    });
  };

  borrar = (value) => {
    const prof = value.prof;
    const id = value.id;
    const colores = value.color;
    const op = value.op;
    const estado = "Nuevo";
    firebase
      .firestore()
      .collection("ing")
      .where("prof", "==", prof)
      .get()
      .then((qs) => {
        if (qs.docs.length > 1) {
          firebase
            .firestore()
            .collection("comercial")
            .where("prof", "==", prof)
            .where("op", "==", op)
            .get()
            .then((sq) => {
              sq.forEach((doc) => {
                firebase
                  .firestore()
                  .collection("comercial")
                  .doc(doc.id)
                  .delete();
              });
            });

          firebase
            .firestore()
            .collection("ing")
            .doc(id)
            .delete();

          firebase
            .firestore()
            .collection("ddp")
            .where("op", "==", op)
            .get()
            .then((qs) => {
              qs.forEach((doc) => {
                firebase
                  .firestore()
                  .collection("ddp")
                  .doc(doc.id)
                  .delete();
              });
            });

          colores.forEach((color) => {
            firebase
              .firestore()
              .collection("telas")
              .where("op", "==", op)
              .where("color", "==", color)
              .get()
              .then((qs) => {
                qs.forEach((doc) => {
                  firebase
                    .firestore()
                    .collection("telas")
                    .doc(doc.id)
                    .delete();
                });
              });
          });

          var contador = 0;
          var lista = this.state.data;
          lista.map((registro) => {
            const idReg = registro.valores.id;
            if (idReg === id) {
              lista.splice(contador, 1);
            }
            contador++;
            return registro;
          });
          this.setState({ data: lista });
        } else {
          firebase
            .firestore()
            .collection("ing")
            .doc(id)
            .update({
              hojaConsumo: "",
              fichaTecnica: "",
              hc: firebase.firestore.FieldValue.delete(),
              b: [],
              cantidad: firebase.firestore.FieldValue.delete(),
              color: firebase.firestore.FieldValue.delete(),
              cx: firebase.firestore.FieldValue.delete(),
              descripcion: firebase.firestore.FieldValue.delete(),
              edit: firebase.firestore.FieldValue.delete(),
              estado: [estado, prof],
              estadoProf: firebase.firestore.FieldValue.delete(),
              op: "",
              otros: [],
              isEditable: true,
            });

          firebase
            .firestore()
            .collection("comercial")
            .where("prof", "==", prof)
            .where("op", "==", op)
            .get()
            .then((qs) => {
              qs.forEach((doc) => {
                firebase
                  .firestore()
                  .collection("comercial")
                  .doc(doc.id)
                  .update({
                    isEditable: true,
                    op: "",
                    b: [],
                    otros: [],
                    edit: firebase.firestore.FieldValue.delete(),
                  });
              });
            });

          firebase
            .firestore()
            .collection("ddp")
            .where("op", "==", op)
            .get()
            .then((qs) => {
              qs.forEach((doc) => {
                firebase
                  .firestore()
                  .collection("ddp")
                  .doc(doc.id)
                  .delete();
              });
            });

          colores.forEach((color) => {
            firebase
              .firestore()
              .collection("telas")
              .where("op", "==", op)
              .where("color", "==", color)
              .get()
              .then((qs) => {
                qs.forEach((doc) => {
                  firebase
                    .firestore()
                    .collection("telas")
                    .doc(doc.id)
                    .delete();
                });
              });
          });

          const dataUpdated = this.state.data.map((item) => {
            if (item.prof === prof) {
              const otros = item.otros;
              const index = otros.findIndex((item) => item.op === op);
              otros.splice(index, 1, {
                ...otros[index],
                op: "",
                cx: [],
                fichaTecnica: "",
                b: [],
                hojaConsumo: "",
                hc: [],
                descripcion: "",
                fecha: "",
                estado: [estado],
                index: estado.concat(id),
                otros: [],
                edit: [id, op, colores, estado, true],
                valores: {
                  estado: estado,
                },
              });
            }
            return item;
          });
          this.setState({ data: dataUpdated });
        }
      });
  };

  closeModal() {
    this.setState({ modalIsOpen: false, visible: false });
  }

  render() {
    const { data, loading, modalTitleProf, modalTitleOp } = this.state;

    const ingPrincipal = [
      {
        Header: "F. Comercial",
        headerStyle: { fontWeight: "bold" },
        accessor: "cFechaIngreso",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "cFechaIngreso" }],
          }),
        filterAll: true,
      },
      {
        Header: "Factura Proforma",
        width: 150,
        headerStyle: { fontWeight: "bold" },
        accessor: "prof",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "prof" }],
          }),
        filterAll: true,
      },
      {
        Header: "Archivos",
        headerStyle: { fontWeight: "bold" },
        width: 80,
        sortable: false,
        filterable: false,
        Cell: (row) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {row.original.a && (
              <Tooltip title="Factura Proforma">
                <a href={row.original.a} target="_blank" rel="noopener noreferrer">
                  <Icon type="file-text" className="doc-icon-factura" style={{ fontSize: '18px' }} />
                </a>
              </Tooltip>
            )}
          </div>
        ),
      },
      {
        Header: "Cliente",
        headerStyle: { fontWeight: "bold" },
        accessor: "cliente",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "cliente" }],
          }),
        filterAll: true,
      },
      {
        Header: "F. Despacho",
        headerStyle: { fontWeight: "bold" },
        accessor: "cFechaEntrega",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "cFechaEntrega" }],
          }),
        filterAll: true,
      },
      {
        Header: "Estado",
        accessor: "estadoProf",
        width: 100,
        headerStyle: { fontWeight: "bold" },
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["estadoProf"] }),
        filterAll: true,
        Cell: (row) => <StatusTag status={row.value} />,
      },
    ];

    const ingSub1 = [
      {
        Header: "Orden de Producción",
        headerStyle: { fontWeight: "bold" },
        width: 145,
        accessor: "op",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "op" }],
          }),
        filterAll: true,
      },
      {
        Header: "Ficha Técnica",
        headerStyle: { fontWeight: "bold" },
        accessor: "fichaTecnica",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "fichaTecnica" }],
          }),
        filterAll: true,
      },
      {
        Header: "Consumo",
        headerStyle: { fontWeight: "bold" },
        accessor: "hojaConsumo",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "hojaConsumo" }],
          }),
        filterAll: true,
      },
      {
        Header: "Archivos",
        headerStyle: { fontWeight: "bold" },
        width: 100,
        sortable: false,
        filterable: false,
        Cell: (row) => (
          <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
            {row.original.cx && row.original.cx.length > 0 && (
              <Tooltip title="Orden de Producción">
                <a href={row.original.cx} target="_blank" rel="noopener noreferrer">
                  <Icon type="file-pdf" className="doc-icon-op" style={{ fontSize: '18px' }} />
                </a>
              </Tooltip>
            )}
            {row.original.b && row.original.b.length > 0 && (
              <Tooltip title="Ficha Técnica">
                <a href={row.original.b} target="_blank" rel="noopener noreferrer">
                  <Icon type="file-search" className="doc-icon-ft" style={{ fontSize: '18px' }} />
                </a>
              </Tooltip>
            )}
            {row.original.hc && row.original.hc.length > 0 && (
              <Tooltip title="Hoja de Consumo">
                <a href={row.original.hc} target="_blank" rel="noopener noreferrer">
                  <Icon type="file-done" className="doc-icon-hc" style={{ fontSize: '18px' }} />
                </a>
              </Tooltip>
            )}
            {row.original.moldesUrl && (
              <Tooltip title="Moldes">
                <a
                  href={row.original.moldesUrl}
                  onClick={(e) => { e.preventDefault(); downloadFile(row.original.moldesUrl, row.original.moldes); }}
                >
                  <Icon type="file-zip" className="doc-icon-moldes" style={{ fontSize: '18px' }} />
                </a>
              </Tooltip>
            )}
            {row.original.tizadoDdpUrl && (
              <Tooltip title="Tizado DDP">
                <a
                  href={row.original.tizadoDdpUrl}
                  onClick={(e) => { e.preventDefault(); downloadFile(row.original.tizadoDdpUrl, row.original.tizadoDdp); }}
                >
                  <Icon type="file-zip" className="doc-icon-tizado-ddp" style={{ fontSize: '18px' }} />
                </a>
              </Tooltip>
            )}
          </div>
        ),
      },
      {
        Header: "Descripción",
        headerStyle: { fontWeight: "bold" },
        accessor: "descripcion",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "descripcion" }],
          }),
        filterAll: true,
      },
      {
        Header: "Fecha Inicio",
        headerStyle: { fontWeight: "bold" },
        accessor: "fecha",
      },
      {
        Header: "Listo",
        headerStyle: { fontWeight: "bold" },
        accessor: "estado",
        width: 100,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, {
            keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "estado" }],
          }),
        filterAll: true,
        Cell: (row) => <StatusTag status={row.value === "Nuevo" ? "" : row.value} />,
      },
      {
        Header: "Estado",
        accessor: "estadoProf",
        width: 100,
        headerStyle: { fontWeight: "bold" },
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["estadoProf"] }),
        filterAll: true,
        Cell: (row) => <StatusTag status={row.row.op ? row.value : ""} />,
      },
      {
        Header: "Acciones",
        headerStyle: { fontWeight: "bold" },
        width: 80,
        sortable: false,
        filterable: false,
        Cell: (row) => {
          const menu = (
            <Menu>
              <Menu.Item 
                key="details" 
                onClick={() => {
                  this.setState({
                    visible: true,
                    telaData: row.original.detalles,
                    modalTitleOp: row.original.op,
                    modalTitleProf: row.original.prof,
                  });
                }}
              >
                Ver Detalles
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item 
                key="edit" 
                onClick={() => {
                  this.setState({
                    editModalVisible: true,
                    targetIng: row.original.edit
                  });
                }}
              >
                Editar
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item 
                key="delete" 
                onClick={() => this.prepBorrar(row.original.prof, row.original.op)}
                style={{ color: 'red' }}
              >
                Borrar
              </Menu.Item>
            </Menu>
          );

          return (
            <div className="text-center">
              {row.original.op ? (
                <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
                  <Buttons 
                    className="actions-btn"
                    icon="more" 
                    size="small" 
                  />
                </Dropdown>
              ) : null}
            </div>
          );
        },
      },
    ];
    const ingSub2 = [
      {
        Header: "Color",
        headerStyle: { fontWeight: "bold" },
        accessor: "color",
      },
      {
        Header: "Cantidad",
        headerStyle: { fontWeight: "bold" },
        accessor: "cantidad",
      },
      {
        Header: "Estado",
        width: 130,
        headerStyle: { fontWeight: "bold" },
        accessor: "status",
        Cell: (row) => {
          const status = row.value && row.value[0] && row.value[0][0] ? row.value[0][0] : null;
          return (
            <div className="text-center">
              <StatusTag status={status} />
            </div>
          );
        },
      },
    ];

    const legendItems = [
      { type: 'file-text', className: 'doc-icon-factura', label: 'Factura Proforma' },
      { type: 'file-pdf', className: 'doc-icon-op', label: 'Orden de Producción' },
      { type: 'file-search', className: 'doc-icon-ft', label: 'Ficha Técnica' },
      { type: 'file-done', className: 'doc-icon-hc', label: 'Hoja de Consumo' },
      { type: 'file-zip', className: 'doc-icon-moldes', label: 'Moldes' },
      { type: 'file-zip', className: 'doc-icon-tizado-ddp', label: 'Tizado DDP' },
    ];

    const telasDetalle = [
      {
        Header: "TELAS",
        headerStyle: { backgroundColor: "#F5BC66", color: "white", fontWeight: "bold" },
        columns: [
          { Header: "Fecha Inicio", headerStyle: { fontWeight: "bold" }, accessor: "tFechaIngreso" },
          {
            Header: "Estado",
            headerStyle: { fontWeight: "bold" },
            accessor: "tEstado",
            Cell: (row) => (
              <div className="text-center">
                <StatusTag status={row.value} />
              </div>
            ),
          },
        ],
      },
    ];

    return (
      <div className="content">
        <Modals
          title={
            <div style={{ color: '#1890ff' }}>
              <Icon type="info-circle" style={{ marginRight: '8px' }} />
              Pof: "{modalTitleProf}" | OP: "{modalTitleOp}"
            </div>
          }
          visible={this.state.visible}
          onCancel={this.handleCancel}
          footer={null}
          width={800}
          centered
        >
          <ReactTable
            data={this.state.telaData}
            columns={ingSub2}
            defaultPageSize={10}
            showPagination={this.state.telaData && this.state.telaData.length > 10}
            className="-striped -highlight"
            SubComponent={(row) => {
              return (
                <div style={{ padding: "10px" }}>
                  <ReactTable
                    data={row.original.telas}
                    columns={telasDetalle}
                    defaultPageSize={1}
                    showPagination={false}
                    style={{ textAlign: "center", margin: "10px 0" }}
                  />
                  <ReactTable
                    data={row.original.corte}
                    columns={cortes}
                    defaultPageSize={1}
                    showPagination={false}
                    style={{ textAlign: "center", margin: "10px 0" }}
                  />
                  <ReactTable
                    data={row.original.costura}
                    columns={costura}
                    defaultPageSize={1}
                    showPagination={false}
                    style={{ textAlign: "center", margin: "10px 0" }}
                  />
                  <ReactTable
                    data={row.original.acabado}
                    columns={acabado}
                    defaultPageSize={1}
                    showPagination={false}
                    style={{ textAlign: "center", margin: "10px 0" }}
                  />
                  <ReactTable
                    data={row.original.almacen}
                    columns={almacen}
                    defaultPageSize={1}
                    showPagination={false}
                    style={{ textAlign: "center", margin: "10px 0 40px 0" }}
                  />
                </div>
              );
            }}
          />
        </Modals>

        <EditPasswordModal
          visible={this.state.editModalVisible}
          onCancel={() => this.setState({ editModalVisible: false })}
          targetPath="/Ingenieria/EditIngenieria"
          history={this.props.history}
          passData={this.state.targetIng}
        />

        <EngineeringDeletionModal
          visible={this.state.deleteModalIsOpen}
          onCancel={() => this.setState({ deleteModalIsOpen: false })}
          onDeleteSuccess={this.onDeleteSuccess}
          op={this.state.targetOp}
        />

        <Row>
          <Col xs={12}>
            <Card className="card-tasks">
              <CardHeader>
                <CardTitle tag="h4" className="text-center">
                  Seguimiento de Procesos PCP
                </CardTitle>
              </CardHeader>
              <CardBody>
                <TableLegend items={legendItems} />
                <ReactTable
                  data={data}
                  filterable
                  defaultFilterMethod={(filter, row) =>
                    row[filter.id] && String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                  }
                  columns={ingPrincipal}
                  noDataText="Sin Registros"
                  loading={loading}
                  loadingText="Cargando datos..."
                  defaultPageSize={10}
                  className="-striped -highlight"
                  minRows={0}
                  expanded={this.state.expanded}
                  onExpandedChange={(newExpanded) =>
                    this.setState({ expanded: newExpanded })
                  }
                  SubComponent={(row) => {
                    return (
                      <div className="subrow-container">
                        <ReactTable
                          data={row.original.otros}
                          columns={ingSub1}
                          noDataText="No hay órdenes de producción asociadas"
                          pageSize={row.original.otros.length}
                          showPagination={false}
                          className="-striped -highlight"
                        />
                      </div>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default RegularTables;
